import { SavedReportEvaluationWire } from 'app/area/shared/saved-reports/types';

import { SavedReportCompanyReport } from '../types-store';
import { SavedReportCompanyReportWire, SavedReportDetailsValueWire } from '../types';
import { normalizeSequence } from './normalize-sequence';

export const mapSavedReportsFromWire = (
  savedReports: SavedReportCompanyReportWire[],
  evaluationsWire: SavedReportEvaluationWire[]
): SavedReportCompanyReport[] => {
  return normalizeSequence(savedReports
    ?.map(savedReport => ({
      code: {
        value: savedReport.code?.v,
        description: savedReport.code?.d
      },

      reportIdCell: savedReport.details?.reportId?.cell,
      reportIdRange: savedReport.details?.reportId?.range,
      reportNameCell: savedReport.details?.reportName?.cell,
      reportNameRange: savedReport.details?.reportName?.range,
      reportResultCell: savedReport.details?.reportResult?.cell,
      reportResultRange: savedReport.details?.reportResult?.range,

      selectedReport: evaluationsWire
        ?.find(evaluation => evaluation.code?.v === savedReport.code?.v)
        ?.report,

      editable: evaluationsWire
        ?.find(evaluation => evaluation.code?.v === savedReport.code?.v)
        ?.editable ?? false,

      sequence: undefined,

      disabled: undefined
    })));
};

export const mergeSavedReportsWithEvaluations = (
  savedReports: SavedReportCompanyReport[],
  evaluationsWire: SavedReportEvaluationWire[]
): SavedReportCompanyReport[] => {
  return savedReports
    ?.map(savedReport => ({
      ...savedReport,

      code: {
        value: savedReport.code?.value,
        description: savedReport.code?.description
      },

      selectedReport: evaluationsWire
        ?.find(evaluation => evaluation.code?.v === savedReport.code?.value)
        ?.report,

      editable: evaluationsWire
        ?.find(evaluation => evaluation.code?.v === savedReport.code?.value)
        ?.editable ?? false
    }));
};

export const mapSavedReportsToWire = (savedReports: SavedReportCompanyReport[]): SavedReportCompanyReportWire[] => {
  return savedReports
    ?.map(savedReport => {

      const reportId = normalizeCellRange(savedReport.reportIdCell, savedReport.reportIdRange);
      const reportName = normalizeCellRange(savedReport.reportNameCell, savedReport.reportNameRange);
      const reportResult = normalizeCellRange(savedReport.reportResultCell, savedReport.reportResultRange);

      return {
        code: {
          v: savedReport.code?.value
        },

        details: {
          ...(!!reportId && { reportId }),
          ...(!!reportName && { reportName }),
          ...(!!reportResult && { reportResult })
        }
      };
    }) ?? [];
};

const normalizeCellRange = (cellValue: string, rangeValue: string): SavedReportDetailsValueWire => {

  const cell = cellValue?.trim() ?? '';
  const range = rangeValue?.trim() ?? '';

  if (cell.length === 0 && range.length === 0) {
    return undefined;
  }

  return { cell, range };
};
